import React from 'react';
import { connect } from 'react-redux';
import DocumentMeta from 'react-document-meta';
import styled from 'styled-components';
import {getRaces, switchRace} from '../actions/race';
import SidebarWidgets from "./SidebarWidgets";
import PlayIcon from '../icons/play';
import SearchSmallIcon from '../icons/search-small';

class HomePage extends React.Component {

  constructor(props, context) {
    super(props, context);

    props.switchRace(null);
  }

  state = {
    search: '',
    currentTab: 'recent'
  };

  componentDidMount() {
    this.props.getRaces();

    document.title = 'RaceResults 360';
  }

  searchChange(e) {
    this.setState({search: e.target.value});
  }

  clearSearch() {
    this.setState({search: ''});
    this.props.getRaces();
  }

  searchRaces(event) {
    event.preventDefault();
    this.props.getRaces(this.state.search);
    return false;
  }

  navigateToRace(race) {
    let eventId = '';
    if (race.event_mapping && race.event_mapping.length > 0) {
      eventId = race.event_mapping[0].key;
    }
    this.props.history.push(`/race/${race.race_id}/${eventId}`);
  }


  render() {

    const meta = {
      title: document.title,
      description: `Online Race Results for Marathons, Triathlons, 5Ks, fun-runs and more. Powered by RaceResults 360.`,
      canonical: location.href,
      meta: {
        charset: 'utf-8',
        name: {
          keywords: `raceresults360,marathons,triathlons,5k,running,cycling,athletes,runners,triathletes`
        }
      }
    };

    const {races} = this.props;

    let racesList = races;

    if (this.state.currentTab === 'upcoming') {
       racesList = races.filter(x => new Date(x.event_date) > new Date()).reverse();
    } else if (this.state.currentTab === 'recent') {
        racesList = races.filter(x => new Date(x.event_date) < new Date(new Date().getTime() + 1000*60*60*24*7));
    }

    if (this.props.isMobile) {
      return (
        <div>
          <DocumentMeta {...meta} />
          <div className="header">
            <h5 className="title" style={{backgroundColor: this.props.color}}>All Races</h5>
            <div className="info-block clearfix">
              <h3>Race Search</h3>
            </div>
          </div>
          <form onSubmit={this.searchRaces.bind(this)}>
            <div className="form-search clearfix">



              <p>
                <label htmlFor="input-search" className="hidden">Search for:</label>
                <input id="input-search" type="text" value={this.state.search} className="field-search" onChange={this.searchChange.bind(this)} />
                <button className="btn-search" onClick={this.searchRaces.bind(this)}><SearchSmallIcon /></button>
              </p>



            </div>

            <div className="buttons">
              <div className="buttons-outer">
                <div className="buttons-inner clearfix">
                  <a className="button-clear" onClick={this.clearSearch.bind(this)}>Clear</a>
                  <a className="button-search" onClick={this.searchRaces.bind(this)}><span>Search</span></a>
                </div>
              </div>
            </div>
          </form>
          <div className="menu" id="filter-results">
              <ul>
                <li>
                  <div className="sub-menu">
                    <ul id="filter-events">

                      {racesList.map((race, idx) => (
                        <li key={idx}>
                          <a href="javascript:;" onClick={this.navigateToRace.bind(this, race)} className="race">
                            <PlayIcon />
                            <p className="raceListing">
                              <span className="raceName">{race.name}</span>
                              <span className="raceLocation">{`${race.city}, ${race.state}`}</span>
                              <span className="raceDate">{race.event_date}</span>
                            </p>
                          </a>
                        </li>
                      ))}


                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
      );
    }

    const ThemeColorA = styled.a`
      color: ${this.props.color} !important;
    `;

    const ThemeColorStrong = styled.strong`
      color: ${this.props.color} !important;
    `;

    return (
      <div className="section-search-results">
        <DocumentMeta {...meta} />
        <div className="section-head">
          <h1 className="section-title">
        <span>
          Search
          &nbsp;
          <strong>Race</strong>
          &nbsp;
          Results
        </span>
          </h1>

          <div className="cols clearfix">
            <div className="col col-1of2">
              <div className="search search-large">
                <form onSubmit={this.searchRaces.bind(this)}>
                  <label htmlFor="q" className="hidden">Search</label>

                  <input type="text" value={this.state.search} onChange={this.searchChange.bind(this)} name="searchInput" id="searchInput" title="Search Event" placeholder="Search Event" className="search-field" />

                  <button type="submit" id="searchEvent" className="search-btn" onClick={this.searchRaces.bind(this)} style={{backgroundColor: this.props.color}}>
                    <i className="ico-search" />
                  </button>
                  <button id="searchReset" className="search-btn reset-btn" onClick={this.clearSearch.bind(this)}>
                    CLEAR SEARCH
                  </button>
                </form>
              </div>
            </div>

          </div>
        </div>

        <div className="section-body flexbox-container">
          <div className="table-search content">
            <div className="table-head">
              <h2 className={this.state.currentTab === 'recent' ? `table-title home-tab active` : 'table-title home-tab'}
                onClick={() => this.setState({currentTab: 'recent'})}>
                  {this.state.currentTab !== 'recent' ? (
                    <ThemeColorA>Recent Events</ThemeColorA>
                  ) : (
                    <a>Recent Events</a>
                  )}
              </h2>
              <h2 className={this.state.currentTab === 'upcoming' ? `table-title home-tab active` : 'table-title home-tab'}
                onClick={() => this.setState({currentTab: 'upcoming'})}>
                {this.state.currentTab !== 'upcoming' ? (
                  <ThemeColorA>Upcoming Events</ThemeColorA>
                ) : (
                  <a>Upcoming Events</a>
                )}
              </h2>
            </div>

            <div className="table-body">
              <table id="table-races" width="100%" border="0" cellSpacing="0" cellPadding="0">
                <tbody>
                  {racesList.map((race, idx) => (
                  <tr className="eventrow" key={idx} onClick={this.navigateToRace.bind(this, race)}>
                    <td width="38">
                      <i className="ico-arrow" />
                    </td>

                    <td><h4>{race.name}</h4></td>

                    <td>
                      <ThemeColorStrong>{`${race.city}, ${race.state}`}</ThemeColorStrong>
                    </td>

                    <td>
                      <span>{race.event_date}</span>
                    </td>
                  </tr>
                  ))}
                  {racesList.length === 0 &&
                    <tr>
                        <td colSpan="4">No Events Found</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            {!this.state.search &&
              <div className="table-actions">
                {/*}<span className="link-more">&gt;&gt; more</span>*/}
              </div>
            }
          </div>

          <SidebarWidgets />
          { false &&
            <div className="sidebar">
              <ul className="widgets">
                <li className="widget widget-ad">
                  <img src="../styles/images/temp/ad.jpg" alt="" />
                </li>

                <li className="widget widget-ad">
                  <img src="../styles/images/temp/ad.jpg" alt="" />
                </li>
              </ul>
            </div>
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    races: state.rr360.races,
    accountId: state.rr360.accountId,
    isMobile: state.rr360.isMobile,
    color: state.rr360.theme.primaryColor
  };
}


export default  connect(mapStateToProps, {getRaces, switchRace})(HomePage);



// WEBPACK FOOTER //
// ./src/components/HomePage.js